module.exports = __webpack_public_path__ + "static/media/thumbnail.feca3990.jpg";